import {
  COMMON_QUERY_CONFIG,
  COMMON_QUERY_RULES_CONFIG,
  COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
  COMMON_VIDEO_QUERY_RULES_CONFIG,
  DEFAULT_PRODUCT_VALUE,
  ruleNewsPlus
} from './shared/configs';

enum SECTION_ENUM {
  HEARD_ON_THE_STREET = 'Heard on the Street',
  BANKING = 'Banking',
  INVESTING = 'Investing',
  COMMODITIES = 'Commodities & Futures',
  CURRENCIES = 'Currencies',
  REGULATION = 'Regulation',
  STOCKS = 'Stocks',
  DEFAULT = 'Default',
  RELATED_OPINION = 'Related Opinion',
  VIDEO = 'Video'
}

const MAIN = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    not: [...(COMMON_QUERY_RULES_CONFIG.not ?? []), ruleNewsPlus],
    or: [
      { terms: { key: 'DJEThing', value: ['finance'] } },
      { terms: { key: 'SectionType', value: ['heard on the street'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['finance/banking'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['finance/investing'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['finance/stocks'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['finance/commodities-futures'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['finance/currencies'] } },
      { terms: { key: 'PrimaryDJEThing', value: ['finance/regulation'] } }
    ]
  }
};

const HEARD_ON_THE_STREET = {
  ...COMMON_QUERY_CONFIG,
  query: {
    and: [{ terms: { key: 'Product', value: DEFAULT_PRODUCT_VALUE } }],
    not: [{ terms: { key: 'AvailabilityFlags', value: ['WSJNOSF'] } }],
    or: [{ terms: { key: 'SectionType', value: ['heard on the street'] } }]
  }
};

const BANKING = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['finance/banking'] } }]
  }
};

const INVESTING = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['finance/investing'] } }]
  }
};

const COMMODITIES = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['finance/commodities-futures'] } }]
  }
};

const CURRENCIES = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['finance/currencies'] } }]
  }
};

const REGULATION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['finance/regulation'] } }]
  }
};

const STOCKS = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_QUERY_RULES_CONFIG,
    or: [{ terms: { key: 'DJEThing', value: ['finance/stocks'] } }]
  }
};

const RELATED_OPINION = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_RELATED_OPINION_QUERY_RULES_CONFIG,
    and: [
      ...(COMMON_RELATED_OPINION_QUERY_RULES_CONFIG.and ?? []),
      {
        codes_with_significance: {
          key: 'djething',
          significance: ['significant'],
          value: [
            'finance',
            'heard on the street',
            'finance/banking',
            'finance/investing',
            'finance/commodities-futures',
            'finance/currencies',
            'finance/regulation',
            'finance/stocks'
          ]
        }
      }
    ],
    or: [],
    not: []
  }
};

const VIDEO = {
  ...COMMON_QUERY_CONFIG,
  query: {
    ...COMMON_VIDEO_QUERY_RULES_CONFIG,
    or: [{ term: { key: 'DJEThing', value: 'finance' } }, { prefix: { key: 'DJEThing', value: 'finance/' } }],
    not: []
  }
};

export {
  MAIN,
  SECTION_ENUM,
  HEARD_ON_THE_STREET,
  BANKING,
  INVESTING,
  COMMODITIES,
  CURRENCIES,
  REGULATION,
  STOCKS,
  RELATED_OPINION,
  VIDEO
};
